import React from 'react';

function HistoricoObs({obs}) {
    const newob = obs.split('<br>');
return <div>{newob.map((item)=>(<>{item} <br /></>))}</div>;

}

export default HistoricoObs;